module.exports = __webpack_public_path__ + "img/制御工学5_1.f4160b9b.png";